import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Card, Table, Tooltip, Space, } from "antd";
import IconButton from "components/ui/Button/IconButton";
import { ImagePaths } from "utils/ImagePath";
import ConfigurationFilter from "../ConfigurationFilter";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import useApiData from "components/common/useGetApiData";
import { SALARY_COMPONENT } from "constants";
import {checkUserPermissionFunc, deleteDraftItemsById} from "components/common/CommonFuntion";
import { CommonDeletePopup } from 'components/common/CommonComponent';
import { getSalaryComponentTblData } from "hooks/api/configurationApi/payrollPeriodApi";
import useApiMethods from "hooks/apiConfig/method/apiMethods";
import {NEW_SALARY_COMPONENT} from "constant"

const initialData = {
  salary_component_code: "",
  salary_component_type: "",
  salary_component_status: "",
}

function SalaryComponent() {
  let query = "";
  let queryRef = useRef("");
  const pageSize = 10;
  const authtoken = sessionStorage.getItem("token");

  const [editVisible, setEditVisible] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState();
  const [searchText, setSearchText] = useState("");
  const [dataUpdated, setDataUpdated] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [sorting, setSorting] = useState("");
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDatas, setFilterDatas] = useState({ initialData });
  const [reorderedColumns, setReorderedColumns] = useState([]);
  const [isDraft, setIsDraft] = useState(false);
  const [deleteItem, setDeleteClicked] = useState({ id: undefined, isDeleteClicked: false });
  const tableContainerHeight = isDraft ? "77.5vh" : "72vh";

  const navigate = useNavigate();

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
  }, [authtoken]);

  const userPermission = checkUserPermissionFunc("configuration", "Salary Component", "SubMenu");

  const queryString =
  "?page_no=" + pageNo +
  "&page_size=" + pageSize +
  "&code=" + (filterDatas?.salary_component_code ? filterDatas?.salary_component_code : "") +
  "&component_type=" + (filterDatas?.salary_component_type ? filterDatas?.salary_component_type : "") +
  "&is_active=" + (filterDatas?.salary_component_status !== undefined ? filterDatas?.salary_component_status : "") +
  "&search=" + searchText + (sorting ? `&${sorting}` : "");

  // const [data, pageInfo, loading, _message, refetch] = useApiData(getSalaryComponentTblData, {
  //   pageNo,
  //   pageSize,
  //   queryString,
  //   searchText,
  //   sorting
  // });

  const { fetch, update } = useApiMethods();
  const [data, setData] = useState([]);
  const [pageInfo, setPageInfo] = useState([])
  const [loading, setLoading] = useState(false);
  const [filter, setFilter]=useState({pageNo:'', pageSize:'', query:'', search:'', sorting:''})

  const fetchSalaryComponent = async () => {        
    const res = await fetch(
      NEW_SALARY_COMPONENT, 
      filter,
      setLoading
    );
    if (res?.status) {
      setData(res.data.result);
      setPageInfo({
        pageNo: res.data.page_no,
        pageSize: res.data.page_size,
        totalCount: res.data.total_count,
        noOfPages: res.data.no_of_pages,
      });
    }
  };

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
    fetchSalaryComponent();
  }, [filter, editVisible]);

  // useEffect(() => {
  //   if (_message && _message.isErrorMsg && _message.errorMsgText) {
  //     ToastMsg('error', _message.errorMsgText);
  //   }
  // }, [_message, _message.errorMsgText]);

  const addClick = () => {
    setEditVisible(false);
    setSelectedDetails({});
    navigate('/configuration/salarycomponent/add', { state: { fromEdit: false, editDetails: {}, isActive: userPermission?.active !== undefined ? userPermission?.active : true } });
  };

  const handleEditClick = (details) => {
    if (editVisible && Object.keys(selectedDetails).length > 0) {
      ToastMsg("warning", "Please cancel the existing edit operation!")
    }
    else if (!editVisible) {
      setEditVisible(true);
      navigate('/configuration/salarycomponent/add', { state: { fromEdit: true, editDetails: details, isActive: userPermission?.active !== undefined ? userPermission?.active : true } });
      setSelectedDetails(details);
    }
  };

  const handleSearch = () => {
    setEditVisible(false)
    setSelectedDetails({});
    setPageNo(1);
    setFilter(1,
      pageSize,
      queryString,
      searchText,
      sorting);
    setDataUpdated(!dataUpdated);
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
    const sortQuery = sorter.order ? `${sortorder}column=${sorter.columnKey}` : ""
    queryRef.current = isDraft ? `is_draft=True` : "" + queryString;
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: pagination.current, 
      pageSize: pagination.pageSize || prevFilter.pageSize, 
      query: queryRef.current, 
      sorting: sortQuery,
    }));
    setSorting(sortQuery)
  }

  // filter start
  const renderFilter = (data) => {
    setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
    setPageNo(1);
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: 1, 
      pageSize: pageSize || prevFilter.pageSize, 
      query: `code=${data?.salary_component_code ? data?.salary_component_code : ""}&component_type=${data?.salary_component_type ? data?.salary_component_type : ""}&is_active=${data?.salary_component_status !== undefined ? data?.salary_component_status : ""}`,
      search: searchText,
      sorting: sorting,
    }));
    setFilterVisible(false);
  }

  const ClosePopUp = () => {
    setFilterVisible(false);
  }

  const clearFilter = () => {
    setFilterDatas(initialData);
    setPageNo(1);
    setFilter(1,
      pageSize,
      queryString,
      searchText,
      sorting);
  }
  //filter end

  const columns = [
    {
      title: "Salary Component Code",
      dataIndex: "code",
      key: "code",
      sorter: true,
      width: "25%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record?.code?.length > 20 ?
          <Tooltip title={record?.code}>{<span style={{ color: colors }}>{record?.code?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record?.code ? record?.code : "-"}</p>)
      }
    },
    {
      title: "Salary Component",
      dataIndex: "salary_component_name",
      key: "salary_component_name",
      sorter: true,
      width: "25%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record?.salary_component_name?.length > 20 ?
          <Tooltip title={record?.salary_component_name}>{<span style={{ color: colors }}>{record?.salary_component_name?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record?.salary_component_name ? record?.salary_component_name : "-"}</p>)
      }
    },
    {
      title: "Component Type",
      dataIndex: "component_type",
      key: "component_type",
      sorter: true,
      width: "25%",
      fixed: "left",
      render: (_, record) => {
        const styles = {
          color: record?.is_active ? "black" : "#CACACA",
          textTransform: "capitalize"
        };
        return (record?.component_type?.length > 20 ?
          <Tooltip title={`${record?.component_type}s`}>{<span style={styles}>{record?.component_type?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={styles}>{record?.component_type ? `${record?.component_type}s` : "-"}</p>)
      }
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: true,
      width: "15%",
      render: (_, record) =>
        record?.is_active === true ? (
          <span style={{ color: "black" }}>Active</span>
        ) : (
          <span style={{ color: "#CACACA" }}>Inactive</span>
        ),
      align: 'center',
      fixed: "left",
    },
  ];
  if (userPermission?.edit) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "10%",
      align: 'center',
      fixed: "left",
      render: (_, record) => (
        <div className="flex justify-center items-center">
          <Space size={"middle"}>
            <IconButton
              title="Edit"
              icon={<img src={ImagePaths.edit.default} alt="Edit" />}
              onClick={() => (loading ? "" : handleEditClick(record))}
              testID={'ug_btn_edit'}
            />
            {record?.is_draft === true ?
              <IconButton
                title="Delete"
                icon={<img src={ImagePaths.delete.default} alt="Delete" />}
                onClick={() => (loading ? "" : handleDeleteClicked(record?.id))}
                testID={'ug_btn_delete'}
              /> : null}
          </Space>
        </div>
      ),
    })
  }

  //draft delete start
  const handleDeleteClicked = (id) => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      id: id,
      isDeleteClicked: true
    }));
  }

  const handleCancelBtn = () => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      id: undefined,
      isDeleteClicked: false
    }));
  }

  const handleDeleteBtn = async (id) => {
    try {
      // Create FormData object
      const formData = new FormData();
      formData.append("id", id);
      formData.append("is_active", false);
  
      if (isDraft) {
        formData.append("draft_delete", true);
        formData.append("is_draft", true);
      }
  
      // Make the API call
      const response = await update(NEW_SALARY_COMPONENT, formData);
  
      if (response?.status) {
        ToastMsg("success", "Salary Component deleted successfully.");
        handleDraft();
      } else {
        ToastMsg("error", response.message || "Failed to delete the Salary Component.");
      }
    } catch (error) {
      ToastMsg("error", error.message);
    } finally {
      handleCancelBtn();
    }
  }//draft delete end

  const handleFilter = () => {
    setFilterVisible(true)
  }

  const handleDraft = () => {
    setIsDraft(true);
    setFilterVisible(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = `is_draft=True`
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: 1, 
      query: queryRef.current, 
      sorting: "",
    }));
  }

  const handleBackToHome = () => {
    setIsDraft(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = "";
    setFilter(1,
      pageSize,
      queryRef.current,
      queryString,
      searchText,
      "");
  }

  const handleStateChanges = (search = "", reorderedList = []) => {
    setSearchText(search)
    setReorderedColumns(reorderedList)
  }

  const printData =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&code=" + (filterDatas?.salary_component_code ? filterDatas?.salary_component_code : "") +
    "&component_type=" + (filterDatas?.salary_component_type ? filterDatas?.salary_component_type : "") +
    "&is_active=" + (filterDatas?.salary_component_status !== undefined ? filterDatas?.salary_component_status : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");

  const styles = {
    fltContainer: {
      border: "1px solid #cbcbcb",
      height: tableContainerHeight,
    },
  }

  return (
    <Card className="h-full overflow-hidden">
      <div className={"h-1/6"} >
        <CommonTblHeader pageName={"Salary Component"}
          pageInfo={pageInfo}
          handleSearch={handleSearch} selectedDetails={selectedDetails} addClick={addClick}
          onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
          handleDraft={handleDraft} isDraft={isDraft} handleBackToHome={handleBackToHome}
          url={NEW_SALARY_COMPONENT} query={printData}
          isAddRequired = {userPermission?.add ? true : false}
          isDraftRequired = {userPermission?.draft ? true : false}
          testID = {'hs'}
        />
      </div>
      <div className="h-5/6 flex justify-center items-center  mt-1">
        {filterVisible ?
          <div className="w-1/4 mt-5" style={styles.fltContainer}>
            <ConfigurationFilter
              pageName={"SalaryComponents"}
              filterDatas={filterDatas}
              closeFilter={ClosePopUp}
              filteredData={renderFilter}
              clearData={clearFilter} />
          </div>
          : null}
        <div className={filterVisible ? "mt-5 w-3/4" : "mt-5 w-full"} style={styles.fltContainer}>
        <Table
          columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
          dataSource={data?.length > 0 ? data : null}
          loading={loading}
          style = {{"--table-container-height": tableContainerHeight}}
          scroll={{ y: `calc(${tableContainerHeight} - 140px)` }}
          onChange={handleTableChange}
          pagination={{
            style: { marginRight: 20, padding: 0 },
            defaultPageSize: pageSize,
            showSizeChanger: false,
            showQuickJumper: true,
            total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
            pageSizeOptions: ["10", "20", "30"],
            pageSize,
            defaultCurrent: pageNo,
          }}
          key={isDraft ? (dataUpdated ? "draftUpdated" : "draftNotUpdated") : (dataUpdated ? "updated" : "not-updated")}
        />
        </div>
      </div>
      {deleteItem.isDeleteClicked ? <CommonDeletePopup handleCancelBtn={handleCancelBtn} handleDeleteBtn={() => handleDeleteBtn(deleteItem.id)} /> : null}
    </Card>
  );
}

export default SalaryComponent;